import { QRCode } from '@getstep/qrcode-dom'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import { useCSSVariables } from '../../lib/hooks/useCSSVariables'
import type { ThemeOptions } from '../../lib/utils/withTheme'
import { Text } from '../text'
import styles from './hero-qrcode.module.scss'

export const HeroQRCode: FunctionComponent<Props> = ({
    url = '',
    theme = 'primary',
    hasBackground = true,
    children,
}) => {
    const themeColors = useCSSVariables(
        {
            primary: 'theme-primary',
            secondary: 'theme-secondary',
        },
        'section'
    )

    const link = url || process.env.NEXT_PUBLIC_ORGANIC_DOWNLOAD_URL

    if (!link) {
        return null
    }

    return (
        <div className={classNames(styles['qr-code'])}>
            <div
                className={classNames(
                    styles['qr-container'],
                    hasBackground && styles['with-background']
                )}
                data-testid='qrcode.image'
            >
                <QRCode
                    size={100}
                    width='100'
                    height='100'
                    value={link}
                    backgroundColor='transparent'
                    quietZone={0}
                    linearGradient={{
                        stops: [
                            {
                                color: themeColors?.secondary ?? '#c772fd',
                                offset: 0,
                            },
                            {
                                color: themeColors?.primary ?? '#f6629d',
                                offset: 1,
                            },
                        ],
                    }}
                />
            </div>
            <div className={styles['cta-container']}>
                {children ?? (
                    <Text color={theme && 'primary'} typeStyle='body-lg' bold>
                        Scan to get started
                    </Text>
                )}
            </div>
        </div>
    )
}

interface Props {
    url?: string
    theme?: ThemeOptions
    hasBackground?: boolean
    children?: React.ReactNode
}
